import axios from 'axios';
import { apiClient } from './apiClient';
import { Person, Profile, Users } from '../types';
import { ApiError } from '../error/error';




//Λιστα όλων των users
export const getUsersAllList = async () => {
  try {
    const response = await apiClient.get(`api/admin/users`);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.error || 'Failed to get all users', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};


//Πληροφορίες user
export const getUserSingle = async (id: number) => {
  try {
    const response = await apiClient.get(`api/admin/users/${id}`);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to get user', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};


//ADD users
export const addUser = async ( data:any) => {
  try {
    const response = await apiClient.post(`api/admin/users`, data );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to add user', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};

//UPDATE users
export const updateUser = async (id: number, data:any) => {
  try {
    const response = await apiClient.put(`api/admin/users/${id}`, data );

    return response.data.message;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error ||'Failed to update user', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }

};


//Delete users
export const deleteUser= async (id: number) => {
  try {
    const response = await apiClient.delete(`api/admin/users/${id}`);

    return response.data.message;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message || 'Failed to delete user', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};


